export const recruitmentCookieName = 'tm-recruitment-code';